<div class="header">
  <h4 class="header-text" translate="pwaSetupDialog.header"></h4>

  <button
    class="close-btn"
    type="button"
    puButton
    size="m"
    uiType="quaternary"
    [onlyIcon]="true"
    (click)="closeDialog()">
    <pu-icon iconName="close" size="16" />
  </button>
</div>

<div class="body">
  <div class="preview-img">
    <img
      ngSrc="assets/images/pwa/preview.png"
      srcset="
        assets/images/pwa/preview.png     400w,
        assets/images/pwa/preview@x2.png  800w,
        assets/images/pwa/preview-mob.png 343w
      "
      sizes="(max-width: 600px) 100vw, (min-width: 601px) 50vw"
      alt="Refresh"
      height="225"
      width="400"
      priority />
  </div>

  @if (isIOS) {
    <p class="step">
      {{ 'pwaSetupDialog.ios.setupStep1' | translate }}
      <pu-icon class="step-icon" iconName="share" size="16" />
    </p>

    <p class="step">
      {{ 'pwaSetupDialog.ios.setupStep2' | translate }}
      <pu-icon class="step-icon" iconName="plus" size="16" />
    </p>
  } @else {
    <p class="step">
      {{ 'pwaSetupDialog.setupStep1' | translate }}
      <pu-icon class="step-icon" iconName="3points" size="16" />
    </p>

    <p class="step">
      {{ 'pwaSetupDialog.setupStep2' | translate }}
      <pu-icon class="step-icon" iconName="install-mobile" size="16" />
    </p>
  }
  <p class="step" translate="pwaSetupDialog.setupStep3"></p>

  @if (canInstallPwa() || isInstalling()) {
    <hr class="divider" />

    <p class="step" translate="pwaSetupDialog.setupStep4"></p>

    <button
      class="install-btn"
      type="button"
      puButton
      size="m"
      uiType="primary"
      (click)="installPwa()">
      {{ 'pwaSetupDialog.btn.install' | translate }}
    </button>
  }
</div>
